import React from 'react';
import PropTypes from 'prop-types';
import ReactConfirmAlert from 'react-confirm-alert';
import { PopupBody } from '../PopupBody';

function ConfirmPopup({ showPopup, body, onConfirm, onCancel, labelOk, buttonSize, labelCancel, title }) {
    return showPopup
        ? <ReactConfirmAlert
            customUI={() =>
                <PopupBody
                    title={title}
                    body={body}
                    onCancel={onCancel}
                    onOk={onConfirm}
                    labelOk={labelOk}
                    buttonSize={buttonSize}
                    labelCancel={labelCancel}
                />}
          />
        : <></>;
}

ConfirmPopup.propTypes = {
    showPopup: PropTypes.bool.isRequired,
    body: PropTypes.object.isRequired,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func.isRequired,
    labelOk: PropTypes.string,
    labelCancel: PropTypes.string,
    buttonSize: PropTypes.string,
    title: PropTypes.string
};

export default ConfirmPopup;